"use strict";function getUUID$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getUUID$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.base.getUUID";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.7.6"},_a)),exports.getUUID$=getUUID$,exports.default=getUUID$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/base/getUUID.js
// module id = 1053
// module chunks = 106